<template>
    <section class="hero-section text-center py-5">
      <b-container>
        <b-row>
          <b-col lg="6" md="6" sm="12" class="hero-item mb-5">
            <div class="" :class="[{ 'hero-content-rtl': isRTL, 'hero-content-ltr': !isRTL }]">
                <h1 class="hero-header">{{ $t('message.community') }}</h1>
                <p class="lead">{{ $t('message.reviewingRequests') }}</p>
                <b-button variant="warning" class="mt-3 hero-button">{{ $t('message.checkRequests') }}</b-button>
            </div>
          </b-col>
          <b-col lg="6" md="6" sm="12">
            <img :src="require('@/assets/home-slider.svg')" alt="Hero Image" class="img-fluid hero-image">
          </b-col>
        </b-row>
    
      </b-container>
    </section>
  </template>
  
  <script>
  export default {
    name: "HeroSection",
    computed: {
      isRTL() {
        return this.$i18n.locale === 'ar';
      },
    }
  };
  </script>
  
  <style scoped>
  .hero-section {
    /* background-color: #f5f5f5; */
  }
  .hero-image{
    width: 100%;
    /* height: 350px; */
  }
  .hero-content-rtl{
    text-align: right;
  }
  .hero-content-ltr{
    text-align: left;
  }
  .hero-item{
    align-items: center;
    display: flex;
  }
  .hero-header{
    font-size: 2.9rem; /* ضبط حجم الخط حسب احتياجك */
  background-image: linear-gradient(90deg, #003A6E 0%, #3A7BD3 54%, #3B7BD4 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
  }
  .lead{
    color: #92A2AF;
    font-size: 30px;
    font-family: 'Somar-Medium';
    width: 335px;
  }
  .hero-button{
    background-image: linear-gradient(90deg, #FFCA1F 0%, #FFD44A 100%);
    border-radius: 50px;
    width: 200px;
    color: #fff;
    font-size: 25px;
    font-family: 'Somar-bold';
    border-width: 0px;
  }
  .hero-button:hover{
    outline: none;
    border-width: 0px;
    background-image: linear-gradient(90deg,#FFD44A 0% , #FFCA1F 100%);
    transition: all 0.3s ease-in-out;
    color: #fff;
  }
  </style>
  